<template>
<v-menu
  open-on-hover
  :close-on-content-click="false"
  v-model="menuOpened"
  :nudge-width="450"
  max-width="600"
  transition="scale-transition"
  >
  <template v-slot:activator="{ on }">
    <v-chip class="mr-2 mt-2 pb-6 pt-6" v-on="on">
      <div>
        + {{ quantidadeProdutosRestantes }}
        <div></div>
      </div>
    </v-chip>
  </template>
  <v-card>
    <v-card-text class="text--primary mt-0 pt-2">
      <px-requisicao-produto-chip v-for="requisicaoProduto in produtosVisiveis"
                                  :key="requisicaoProduto.id"
                                  :requisicao-produto="requisicaoProduto"
                                  @remove="onRemoveItem"/>
    </v-card-text>
  </v-card>
  </v-menu>
</template>

<script>
import RequisicaoProdutoChip
  from '@/modules/requisicao/geracao/lista-selecao-requisicao-produtos/RequisicaoProdutoChip.vue';

const PRODUTOS_VISIVEIS = 5;

export default {
  props: {
    produtos: {
      type: Array,
    },
  },
  data() {
    return {
      menuOpened: false,
    };
  },
  computed: {
    produtosVisiveis() {
      if (!this.produtos || !this.produtos.length) {
        return [];
      }
      return this.produtos.slice(PRODUTOS_VISIVEIS);
    },
    quantidadeProdutosRestantes() {
      if (!this.produtos || !this.produtos.length) {
        return 0;
      }
      return this.produtos.length - PRODUTOS_VISIVEIS;
    },
  },
  methods: {
    onRemoveItem(requisicaoProduto) {
      this.$emit('remove', requisicaoProduto);
    },
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    pxRequisicaoProdutoChip: RequisicaoProdutoChip,
  },
};
</script>
